import React from 'react';
import cx from 'classnames';

import { Text } from 'components/Text';

import './Badge.scss';

export type BadgeType = 'extra' | 'popular' | 'special' | 'new' | 'limited' | 'vip';
interface BadgeProps {
  title: string;
  type: BadgeType;
}

export const Badge: React.FC<BadgeProps> = ({ title, type }) => {
  return (
    <div
      className={cx('badge-container', {
        'badge-container__colorExtra': type === 'extra',
        'badge-container__colorPopular': type === 'popular',
        'badge-container__colorSpecial': type === 'special',
        'badge-container__colorNew': type === 'new',
        'badge-container__colorLimited': type === 'limited',
        'badge-container__colorVip': type === 'vip',
      })}
    >
      <Text.CapsM hasMobileSize={false} bold className="badge-title">
        {title}
      </Text.CapsM>

      <BadgeTail className="badge-tail" />
    </div>
  );
};

const BadgeTail = ({ ...props }) => (
  <svg width={13} height={22} viewBox="0 0 13 21" fill="#CA1A1A" {...props}>
    <path
      d="M12.5105 0.993408L11.2747 2.27754L9.19054 3.22204L10.0688 4.65082L12.6786 5.25505L12.8849 6.28422L12.2096 7.61326L11.3613 7.27362L10.656 7.51351L10.1887 9.00739L9.42022 8.79765L7.46582 8.91278L7.88166 9.24247L7.41594 9.87203L6.15016 10.067L6.74231 10.3367L5.4599 10.8515L5.1705 11.4211L5.93732 12.4951L6.28994 12.3752L6.74067 11.2011L7.67046 10.8063L8.65012 9.45222L9.06596 9.78191L10.232 11.5054L8.06147 15.7773L6.82729 16.1971L4.50529 15.8877L5.41681 16.6769L4.80639 17.5913L5.56993 20.394L4.70104 20.9934L0 20.9934L0.000229944 0.993408H12.5105Z"
      stroke="none"
    />
  </svg>
);
